interface Props {
  value: number | string;
  onChange: (value: number) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

/**
 * Input numérico estilo "placar":
 * - type="tel" + inputMode="numeric" → teclado numérico no mobile, sem setas no desktop
 * - filtra qualquer não-dígito no onChange
 * - limita a 0-99
 */
export default function ScoreInput({ value, onChange, disabled, ariaLabel }: Props) {
  return (
    <input
      type="tel"
      inputMode="numeric"
      pattern="[0-9]*"
      maxLength={2}
      disabled={disabled}
      aria-label={ariaLabel}
      className="w-12 input py-1 text-center"
      value={value === '' || value === null || value === undefined ? '' : String(value)}
      onFocus={(e) => e.target.select()}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 2);
        onChange(digits === '' ? 0 : parseInt(digits, 10));
      }}
    />
  );
}
